import classNames from 'classnames';
import { FC } from 'react';

import { BoxProps } from '../Box';
import Flex from '../Flex';

// Local Typings
interface Props extends BoxProps {
  noPaddingBottom?: boolean;
  noPaddingTop?: boolean;
  noPaddingX?: boolean;
}

// Local Variables
export const cardContentPadding = 6;

// Component Definition
const CardContent: FC<Props> = ({
  noPaddingBottom = false,
  noPaddingTop = false,
  noPaddingX = false,
  ...props
}) => (
  <Flex
    alignItems="flex-start"
    flexDirection="column"
    fullWidth
    justifyContent="center"
    {...props}
    className={classNames(props.className, 'card_card-content')}
    paddingBottom={noPaddingBottom ? undefined : cardContentPadding}
    paddingTop={noPaddingTop ? undefined : cardContentPadding}
    paddingX={noPaddingX ? undefined : cardContentPadding}
  />
);

export default CardContent;
